import { BaseError } from './errors';

export class BaseNativeError extends BaseError {
  constructor(message: string, innerError?: unknown) {
    super(message, innerError);
  }
}

export class FunctionDoesNotExistError extends BaseNativeError {
  constructor(functionName: string) {
    super(`The function "${functionName}" does not exist`);
  }
}

export class InvalidFunctionNameError extends BaseNativeError {
  constructor(functionName: string) {
    super(`"${functionName}" is not a valid function name`);
  }
}
